import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

// Zimobi: the two destinations of the mobile bottom bar. Icons follow the v4 convention
// (`i-lucide-*`) and match the equivalent entries in the v4 sidebar.
const bottomTabBarMenuItems = accountId => [
  {
    icon: 'i-lucide-contact',
    key: 'contacts',
    labelKey: 'SIDEBAR.CONTACTS',
    featureFlag: FEATURE_FLAGS.CRM,
    toState: frontendURL(`accounts/${accountId}/search`),
    toStateName: 'contacts_dashboard',
    roles: ['administrator', 'agent'],
  },
  {
    icon: 'i-lucide-message-circle',
    key: 'conversations',
    labelKey: 'SIDEBAR.CONVERSATIONS',
    toState: frontendURL(`accounts/${accountId}/dashboard`),
    toStateName: 'home',
    roles: ['administrator', 'agent'],
  },
];

export default bottomTabBarMenuItems;
